import React from 'react'
import styles from './CompainPerformance.module.css'
import { FaHome } from 'react-icons/fa';
import adlogo from '../Images/AdManagerLogo.png'
import Billlogo from '../Images/BillingLogo.png'
import compai from '../Images/compain.png'
import down from '../Images/whitedown.png'
import companyLogo from "../Images/CompanyLogo.png"
import { FaPlay } from 'react-icons/fa';
import { BsFillPauseFill } from 'react-icons/bs';
import commap from '../Images/CompainMap.png'
import chart from '../Images/chart.png'
import graph from '../Images/graph.png'
import { Link } from "react-router-dom";


const CompainPeformance = () => {
    return (
        <>
            <div className={styles.home}>
                <div className={styles.side}>
                    <Link to="/home" className={styles.homeTitle}>
                        <FaHome size={22} className={styles.logo} />
                        <div className={styles.text}>Home</div>
                    </Link>
                    <Link to="/compainpeformance" className={styles.manager}>
                        <div className={styles.admanag}><img src={adlogo} alt="" /></div>
                        <div className={styles.text}>Ad Performance</div>
                    </Link>
                    <div className={styles.manager1}>
                        <div className={styles.admanag}><img src={compai} alt="" /></div>
                        <div className={styles.text}>Campaign name</div>
                    </div>
                    <Link to="/admanager" className={styles.manager1} style={{ marginTop: "11px" }}>
                        <div className={styles.admanag}><img src={adlogo} alt="" /></div>
                        <div className={styles.text}>Ad manager</div>
                    </Link>
                    <Link to="/billing" className={styles.manager}>
                        <div className={styles.admanag}><img src={Billlogo} alt="" /></div>
                        <div className={styles.text}>Billing</div>
                    </Link>

                </div>
                <div className={styles.right}>
                    <div className={styles.inner}>
                        <div className={styles.maps}>
                            <div className={styles.outer}>
                                <div className={styles.comapnydetail}>
                                    <div className={styles.companyname}>
                                        <img src={companyLogo} alt="" className={styles.comLogo} />
                                        <div className={styles.title}>Company name</div>
                                    </div>
                                    <div className={styles.airdrop}>Airdrop 10 $TTH tokens</div>
                                    <div className={styles.companyDetail}>Go to our website and join our free 10$TTH giveaway. You only need to to fill out the form and leave your wallet address.</div>
                                    <div className={styles.go}>Go to</div>
                                    <input type="text" placeholder='Enter promotion' style={{ marginBottom: "45px" }} className={styles.prom} />
                                </div>
                                <div className={styles.statusArea}>
                                    <div className={styles.status}>
                                        <div className={styles.statusText}>Status:</div>
                                        <div className={styles.statuses}><div style={{ color: "#029008" }}>Approved</div><div style={{ color: "#CB6100" }}>Pending</div><div style={{ color: "#FF0000" }}>Declinded</div></div>
                                    </div>
                                    <button className={styles.edit}>Edit Campaign</button>
                                </div>
                            </div>
                            <div className={styles.budget}>
                                <div className={styles.mads}>
                                    <div className={styles.dailyBug}>
                                        <div className={styles.dailyText}>Daily budget (mAds)*</div>
                                        <div className={styles.amountDollar}>
                                            <div className={styles.amountarea}><input type="text" className={styles.amountInput} /><div className={styles.dollor}>$</div></div>
                                            <button className={styles.editBudget}>Edit Budget</button>
                                        </div>
                                    </div>
                                    <div className={styles.playButtons}>
                                        <FaPlay className={styles.pauze} />
                                        <BsFillPauseFill className={styles.play} />
                                    </div>
                                </div>
                                <div className={styles.mapArea}>
                                    <div className={styles.mapGoogle}><img src={commap} style={{ width:"100%", height: "100%" }} alt="" /></div>
                                    <div className={styles.impress}>
                                        <div className={styles.impressText}>Impressions on location</div>
                                        <div className={styles.impressText} style={{ marginTop: "14px" }}>Germany (37%)</div>
                                        <div className={styles.impressText}> UK (23%) </div>
                                        <div className={styles.impressText}>France (21%)</div>
                                        <div className={styles.impressText}>Spain (10%)</div>
                                        <div className={styles.impressText}> Sweden (9%)</div>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.calculation}>
                            <div className={styles.comp}>
                                <div className={styles.compain}><div style={{ marginTop: "23px", marginLeft: "26px" }}> Campaign</div></div>
                                <div className={styles.fields}>
                                    <div className={styles.impr}>
                                        <div className={styles.road}>Impr Road</div>
                                        <div className={styles.value}>600</div>
                                    </div>
                                    <div className={styles.wallet}>
                                        <div className={styles.imprWallet}>Impr Wallet</div>
                                        <div className={styles.imprWall}>600</div>

                                    </div>
                                    <div className={styles.wallet}>
                                        <div className={styles.imprclicks}>Clicks wallet</div>
                                        <div className={styles.imprWall}>300</div>
                                    </div>
                                    <div className={styles.wallet}>
                                        <div className={styles.imprclicks}>Clicks link</div>
                                        <div className={styles.imprWall}>300</div>
                                    </div>
                                    <div className={styles.totel}>
                                        <div className={styles.spend}>Total Spend</div>
                                        <div className={styles.imprWall}>300</div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.charts}>
                                <img src={chart} alt="" style={{ width: "100%", height: "100%" }} />

                            </div>
                        </div>
                        <div className={styles.lowerchart}>
                            <div className={styles.detail}>
                                <div className={styles.impressions}>
                                    <div className={styles.impressText}><div className={styles.impro}>Impressions</div><img src={down} className={styles.downarr} alt="" /></div>
                                    <div className={styles.amount}>1.2K</div>
                                </div>
                                <div className={styles.impressio}>
                                    <div className={styles.impressText}><div className={styles.impro}>Clicks</div><img src={down} className={styles.downarr} alt="" /></div>
                                    <div className={styles.amount}>600</div>
                                </div>
                                <div className={styles.cost}>
                                    <div className={styles.impressText}><div className={styles.impro}>Cost $Mads</div><img src={down} className={styles.downarr} alt="" /></div>
                                    <div className={styles.amount}>1k</div>
                                </div>
                                <div className={styles.grey}>
                                </div>
                            </div>
                            <div className={styles.graph}>
                                <img src={graph} alt="" className={styles.imgGraph} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CompainPeformance
